import { action } from 'satcheljs';

export interface OnCopilotChatDrawerClosedMessage {
    // Whether the action is triggered programmatically or by user interaction.
    isProgrammatic: boolean;
}
export const onCopilotChatDrawerClosed: (
    isProgrammatic: boolean
) => OnCopilotChatDrawerClosedMessage = action(
    'onCopilotChatDrawerClosed',
    (isProgrammatic: boolean): OnCopilotChatDrawerClosedMessage => ({
        isProgrammatic,
    })
);
